import React from 'react';
import ReactDOM from 'react-dom';
import { getTestimonials, submitPublicTestimonial } from '../../services/api';

const defaultTestimonials = [
    {
        id: '1',
        quote: "bs clads transformed our building tower elevation with high-grade ACP Front Elevation. The craftsmanship and structural precision are second to none.",
        name: "David Miller",
        rating: 5
    },
    {
        id: '2',
        quote: "The Facade Glazing and glass curtain wall installation exceeded all thermal and acoustic expectations. Professional execution from start to finish.",
        name: "Sarah Jenkins",
        rating: 5
    },
    {
        id: '3',
        quote: "Their front elevation design gave our headquarters a modern, iconic identity that completely elevated our brand visibility in Coimbatore.",
        name: "Michael Vance",
        rating: 5
    },
    {
        id: '4',
        quote: "Exceptional precision in CNC tray panel fabrication and sub-framing alignment. bs clads delivered our project ahead of schedule with zero defect rework.",
        name: "Robert Chen",
        rating: 5
    },
    {
        id: '5',
        quote: "The custom interior wall cladding and glass partitions created a stunning, acoustically sound environment for our corporate executive suites.",
        name: "Elena Rostova",
        rating: 5
    },
    {
        id: '6',
        quote: "Authorised supplier of genuine Alstone and DOWSIL silicone sealants. Their technical advice on sealant movement capability was invaluable.",
        name: "Karthik Subramanian",
        rating: 5
    }
];

const getInitialItemsPerPage = () => {
    if (typeof window !== 'undefined') {
        const w = window.innerWidth;
        if (w < 768) return 1;
        if (w < 992) return 2;
    }
    return 3;
};

class Testimonials extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            testimonials: defaultTestimonials,
            currentIndex: 0,
            itemsPerPage: getInitialItemsPerPage(),
            isHovered: false,
            showReviewModal: false,
            newRating: 5,
            newName: '',
            newQuote: '',
            isSubmitting: false,
            toastMsg: ''
        };
        this.timer = null;
    }

    async componentDidMount() {
        this.updateItemsPerPage();
        window.addEventListener('resize', this.updateItemsPerPage);
        this.startAutoPlay();

        try {
            const apiData = await getTestimonials(defaultTestimonials);
            if (apiData && Array.isArray(apiData) && apiData.length > 0) {
                this.setState({ testimonials: apiData });
            }
        } catch (e) {
            console.warn('[Testimonials] API fetch fallback to default array.');
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateItemsPerPage);
        this.stopAutoPlay();
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    }

    openReviewModal = () => {
        this.setState({ showReviewModal: true });
        if (typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    };

    closeReviewModal = () => {
        this.setState({ showReviewModal: false });
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    };

    updateItemsPerPage = () => {
        const width = window.innerWidth;
        let count = 3;
        if (width < 768) {
            count = 1;
        } else if (width < 992) {
            count = 2;
        }
        if (this.state.itemsPerPage !== count) {
            this.setState({ itemsPerPage: count, currentIndex: 0 });
        }
    };

    startAutoPlay = () => {
        this.stopAutoPlay();
        this.timer = setInterval(() => {
            if (!this.state.isHovered && !this.state.showReviewModal) {
                this.nextSlide();
            }
        }, 4000);
    };

    stopAutoPlay = () => {
        if (this.timer) clearInterval(this.timer);
    };

    nextSlide = () => {
        const { testimonials, currentIndex, itemsPerPage } = this.state;
        const maxIndex = Math.max(0, testimonials.length - itemsPerPage);
        this.setState({
            currentIndex: currentIndex >= maxIndex ? 0 : currentIndex + 1
        });
    };

    prevSlide = () => {
        const { testimonials, currentIndex, itemsPerPage } = this.state;
        const maxIndex = Math.max(0, testimonials.length - itemsPerPage);
        this.setState({
            currentIndex: currentIndex <= 0 ? maxIndex : currentIndex - 1
        });
    };

    goToSlide = (index) => {
        const { testimonials, itemsPerPage } = this.state;
        const maxIndex = Math.max(0, testimonials.length - itemsPerPage);
        const targetIndex = Math.min(Math.max(0, index), maxIndex);
        this.setState({ currentIndex: targetIndex });
        this.startAutoPlay();
    };

    handleSubmitReview = async (e) => {
        e.preventDefault();
        const { newName, newRating, newQuote } = this.state;

        if (!newName.trim() || !newQuote.trim()) return;

        this.setState({ isSubmitting: true });
        const res = await submitPublicTestimonial({
            name: newName,
            rating: newRating,
            quote: newQuote
        });

        const isSuccess = res && res.success !== false;
        this.setState({
            isSubmitting: false,
            newName: '',
            newRating: 5,
            newQuote: '',
            toastMsg: res.message || (isSuccess ? 'Thank you for your feedback!' : 'Could not connect to server. Please try again later.'),
            toastSuccess: isSuccess
        });
        this.closeReviewModal();

        setTimeout(() => {
            this.setState({ toastMsg: '', toastSuccess: true });
        }, 6000);
    };

    render() {
        const { testimonials, currentIndex, itemsPerPage, showReviewModal, newRating, newName, newQuote, isSubmitting, toastMsg, toastSuccess } = this.state;
        const maxIndex = Math.max(0, testimonials.length - itemsPerPage);
        const totalDots = maxIndex + 1;
        const isSuccessToast = toastSuccess !== false;

        return (
            <div className="section-full mobile-page-padding p-t80 p-b80 overflow-hide" style={{ backgroundColor: '#f8f9fa' }}>
                <style>{`
                    @media (max-width: 767px) {
                        .testimonial-arrow-prev {
                            left: 2px !important;
                            width: 34px !important;
                            height: 34px !important;
                        }
                        .testimonial-arrow-next {
                            right: 2px !important;
                            width: 34px !important;
                            height: 34px !important;
                        }
                        .testimonial-card-box {
                            padding: 24px 18px !important;
                        }
                        .testimonial-quote-text {
                            font-size: 13.5px !important;
                            line-height: 1.65 !important;
                        }
                    }
                `}</style>
                <div className="container">
                    <div className="section-head text-center m-b40">
                        <div className="sx-separator-outer separator-center">
                            <div className="sx-separator bg-white">
                                <h3 className="sep-line-one">Client Testimonials</h3>
                            </div>
                        </div>
                        {/* <p style={{ color: '#444444', fontSize: '15px', maxWidth: '640px', margin: '15px auto 0', textAlign: 'center', fontWeight: '500' }}>
                            Hear from our satisfied clients about their experience with bs clads, high performance ACP Front Elevation, Facade Glazing, and Toughened Glass solutions.
                        </p> */}
                        
                        <div style={{ marginTop: '16px' }}>
                            <button
                                onClick={this.openReviewModal}
                                style={{
                                    padding: '10px 22px',
                                    backgroundColor: '#f03a02',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '30px',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 14px rgba(240, 58, 2, 0.35)',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    transition: 'transform 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.04)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                <i className="fa fa-star" />
                                <span>Write a Review</span>
                            </button>
                        </div>

                        {/* TOAST NOTIFICATION */}
                        {toastMsg && (
                            <div style={{
                                marginTop: '16px',
                                backgroundColor: isSuccessToast ? '#dcfce7' : '#fee2e2',
                                color: isSuccessToast ? '#166534' : '#991b1b',
                                border: `1px solid ${isSuccessToast ? '#86efac' : '#fca5a5'}`,
                                padding: '12px 20px',
                                borderRadius: '30px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                                fontSize: '14px',
                                fontWeight: '700',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                            }}>
                                <i className={`fa ${isSuccessToast ? 'fa-check-circle' : 'fa-exclamation-circle'}`} style={{ fontSize: '16px' }} />
                                <span>{toastMsg}</span>
                            </div>
                        )}
                    </div>

                    {/* CAROUSEL WRAPPER WITH NAVIGATION ARROWS */}
                    <div 
                        style={{ position: 'relative', padding: '0 10px' }}
                        onMouseEnter={() => this.setState({ isHovered: true })}
                        onMouseLeave={() => this.setState({ isHovered: false })}
                    >
                        {/* LEFT PREV BUTTON */}
                        <button
                            onClick={this.prevSlide}
                            className="testimonial-arrow-prev"
                            aria-label="Previous Testimonial"
                            style={{
                                position: 'absolute',
                                left: '-20px',
                                top: '45%',
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                width: '44px',
                                height: '44px',
                                borderRadius: '50%',
                                backgroundColor: '#ffffff',
                                color: '#f03a02',
                                border: '1px solid #eeeeee',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.12)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.25s ease',
                                outline: 'none'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f03a02';
                                e.currentTarget.style.color = '#ffffff';
                                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#ffffff';
                                e.currentTarget.style.color = '#f03a02';
                                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                            }}
                        >
                            <i className="fa fa-chevron-left" style={{ fontSize: '15px' }} />
                        </button>

                        {/* RIGHT NEXT BUTTON */}
                        <button
                            onClick={this.nextSlide}
                            className="testimonial-arrow-next"
                            aria-label="Next Testimonial"
                            style={{
                                position: 'absolute',
                                right: '-20px',
                                top: '45%',
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                width: '44px',
                                height: '44px',
                                borderRadius: '50%',
                                backgroundColor: '#ffffff',
                                color: '#f03a02',
                                border: '1px solid #eeeeee',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.12)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.25s ease',
                                outline: 'none'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f03a02';
                                e.currentTarget.style.color = '#ffffff';
                                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#ffffff';
                                e.currentTarget.style.color = '#f03a02';
                                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                            }}
                        >
                            <i className="fa fa-chevron-right" style={{ fontSize: '15px' }} />
                        </button>

                        {/* SLIDING CAROUSEL CONTAINER */}
                        <div style={{ overflow: 'hidden', padding: '10px 0 20px 0' }}>
                            <div 
                                style={{
                                    display: 'flex',
                                    transition: 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
                                    transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)`
                                }}
                            >
                                {testimonials.map((item, index) => (
                                    <div 
                                        key={item.id || index}
                                        style={{
                                            flex: `0 0 ${100 / itemsPerPage}%`,
                                            maxWidth: `${100 / itemsPerPage}%`,
                                            padding: '0 12px',
                                            boxSizing: 'border-box'
                                        }}
                                    >
                                        <div 
                                            className="testimonial-card-box"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                padding: '30px 24px',
                                                borderRadius: '16px',
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                borderTop: '4px solid #f03a02',
                                                borderLeft: '1px solid #f0f0f0',
                                                borderRight: '1px solid #f0f0f0',
                                                borderBottom: '1px solid #f0f0f0',
                                                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-6px)';
                                                e.currentTarget.style.boxShadow = '0 14px 32px rgba(240, 58, 2, 0.12)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.06)';
                                            }}
                                        >
                                            <div>
                                                {/* Star Rating */}
                                                <div style={{ color: '#f03a02', fontSize: '14px', marginBottom: '12px' }}>
                                                    {[...Array(Number(item.rating) || 5)].map((_, i) => (
                                                        <i className="fa fa-star" key={i} style={{ marginRight: '4px' }} />
                                                    ))}
                                                </div>

                                                {/* Quote Text */}
                                                <p className="testimonial-quote-text" style={{
                                                    color: '#333333',
                                                    fontSize: '14.5px',
                                                    lineHeight: '1.7',
                                                    fontStyle: 'italic',
                                                    marginBottom: '20px'
                                                }}>
                                                    "{item.quote}"
                                                </p>
                                            </div>

                                            {/* Author Info */}
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '14px',
                                                borderTop: '1px solid #f0f0f0',
                                                paddingTop: '16px'
                                            }}>
                                                <div style={{
                                                    width: '46px',
                                                    height: '46px',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'rgba(240, 58, 2, 0.1)',
                                                    color: '#f03a02',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: '800',
                                                    fontSize: '18px',
                                                    flexShrink: 0
                                                }}>
                                                    {item.name ? item.name.charAt(0).toUpperCase() : 'C'}
                                                </div>
                                                <div>
                                                    <h5 style={{ margin: 0, fontWeight: '800', fontSize: '15.5px', color: '#111111' }}>
                                                        {item.name}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* PAGINATION CONTROL DOTS */}
                        {totalDots > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '25px' }}>
                                {[...Array(totalDots)].map((_, dotIdx) => (
                                    <button
                                        key={dotIdx}
                                        onClick={() => this.goToSlide(dotIdx)}
                                        aria-label={`Go to slide ${dotIdx + 1}`}
                                        style={{
                                            width: dotIdx === currentIndex ? '28px' : '10px',
                                            height: '10px',
                                            borderRadius: '5px',
                                            backgroundColor: dotIdx === currentIndex ? '#f03a02' : '#d0d0d0',
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'all 0.35s ease',
                                            outline: 'none',
                                            padding: 0
                                        }}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* USER REVIEW MODAL - PORTAL DIRECTLY ON DOCUMENT.BODY */}
                {showReviewModal && typeof document !== 'undefined' && ReactDOM.createPortal(
                    <div 
                        onClick={this.closeReviewModal} 
                        style={{
                            position: 'fixed', 
                            top: 0, 
                            left: 0, 
                            right: 0, 
                            bottom: 0, 
                            width: '100vw', 
                            height: '100dvh',
                            minHeight: '100%',
                            backgroundColor: 'rgba(0,0,0,0.75)', 
                            zIndex: 9999999, 
                            display: 'flex',
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            padding: '16px',
                            boxSizing: 'border-box',
                            WebkitTapHighlightColor: 'transparent'
                        }}
                    >
                        <div 
                            className="testimonial-modal-box"
                            onClick={(e) => e.stopPropagation()} 
                            style={{
                                backgroundColor: '#ffffff', 
                                borderRadius: '16px', 
                                maxWidth: '480px', 
                                width: '100%',
                                maxHeight: '85dvh',
                                overflowY: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                padding: '26px 20px', 
                                position: 'relative', 
                                boxShadow: '0 20px 50px rgba(0,0,0,0.4)',
                                boxSizing: 'border-box',
                                margin: 'auto'
                            }}
                        >
                            <button 
                                onClick={this.closeReviewModal} 
                                style={{
                                    position: 'absolute', 
                                    top: '14px', 
                                    right: '14px', 
                                    background: '#f1f5f9',
                                    border: 'none', 
                                    borderRadius: '50%', 
                                    width: '32px', 
                                    height: '32px',
                                    fontSize: '16px', 
                                    cursor: 'pointer', 
                                    color: '#64748b',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10
                                }}
                            >
                                ✕
                            </button>

                            <h3 style={{ fontSize: '20px', fontWeight: '800', marginBottom: '6px', color: '#0f172a' }}>Write a Review</h3>
                            <p style={{ fontSize: '13.5px', color: '#64748b', marginBottom: '20px' }}>Share your experience working with BS CLADS.</p>

                            <form onSubmit={this.handleSubmitReview}>
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
                                        Your Rating <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <div style={{ display: 'flex', gap: '8px', fontSize: '24px', color: '#f03a02', cursor: 'pointer' }}>
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <i
                                                key={star}
                                                className={`fa ${star <= newRating ? 'fa-star' : 'fa-star-o'}`}
                                                onClick={() => this.setState({ newRating: star })}
                                            />
                                        ))}
                                    </div>
                                </div>

                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
                                        Your Name <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        placeholder="e.g. Rajesh Kumar"
                                        value={newName}
                                        onChange={(e) => this.setState({ newName: e.target.value })}
                                        style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', boxSizing: 'border-box' }}
                                    />
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
                                        Review Quote / Feedback <span style={{ color: '#e53e3e' }}>*</span>
                                    </label>
                                    <textarea
                                        required
                                        rows="3"
                                        placeholder="Write your review comments here..."
                                        value={newQuote}
                                        onChange={(e) => this.setState({ newQuote: e.target.value })}
                                        style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', boxSizing: 'border-box' }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}>
                                    <button
                                        type="button"
                                        onClick={this.closeReviewModal}
                                        style={{ padding: '10px 18px', borderRadius: '8px', border: '1px solid #cbd5e1', backgroundColor: '#ffffff', color: '#475569', fontWeight: '600', cursor: 'pointer' }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        style={{ padding: '10px 22px', borderRadius: '8px', border: 'none', backgroundColor: '#f03a02', color: '#ffffff', fontWeight: '700', cursor: 'pointer' }}
                                    >
                                        {isSubmitting ? 'Submitting...' : 'Submit Review'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>,
                    document.body
                )}
            </div>
        );
    }
}

export default Testimonials;
